/**
 * Strip HTML tags to get plain text (e.g. for empty check or preview).
 */
export function stripHtml(html: string): string {
  if (!html) return '';
  const doc = typeof document !== 'undefined' ? document : null;
  if (doc) {
    const div = doc.createElement('div');
    div.innerHTML = html;
    return (div.textContent ?? div.innerText ?? '').trim();
  }
  return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}

function normalizeVisibleText(text: string): string {
  return text
    .replace(/\u00a0/g, ' ')
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 */
export function isImageOnlyMessage(html: string): boolean {
  const s = html.trim();
  if (!/<img\b/i.test(s)) return false;
  if (typeof document !== 'undefined') {
    const div = document.createElement('div');
    div.innerHTML = html;
    const imgs = div.querySelectorAll('img');
    if (imgs.length === 0) return false;
    imgs.forEach((el) => el.remove());
    const text = normalizeVisibleText(div.textContent ?? '');
    return text.length === 0;
  }
  const withoutImgs = s.replace(/<img\b[^>]*>/gi, '');
  return normalizeVisibleText(stripHtml(withoutImgs)).length === 0;
}

/** Détecte une pièce jointe (image/PDF) intégrée au HTML — ces messages ne sont pas modifiables. */
export function hasAttachment(html: string): boolean {
  return /<img\b/i.test(html) || /message-attachment-pdf/i.test(html);
}
